// extracted by mini-css-extract-plugin
var _1 = "CommentReactionList-module__active--MDfBP";
var _2 = "CommentReactionList-module__animateUploadProgressBarWidth--RWd0y";
var _3 = "CommentReactionList-module__animatedBackground--_Uvds";
var _4 = "CommentReactionList-module__container--GrGmH";
var _5 = "CommentReactionList-module__count--ro_MP";
var _6 = "CommentReactionList-module__inset--eflQu";
var _7 = "CommentReactionList-module__insetPlus--lMWeJ";
var _8 = "CommentReactionList-module__item--OgX8F";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "container", _5 as "count", _6 as "inset", _7 as "insetPlus", _8 as "item" }
